import BaseServiceApi from './baseapi';

interface CouponList<T> {
  coupons: T[];
}
export interface CouponType {
  code: string;
  type: string;
  currency: string;
  isFixed: true;
  amount: string;
  percent: number;
  trialDays: number;
  amountMin: string;
  amountMax: string;
  createDate: string;
  expireDate: string;
  status: number;
  autoFillIn: boolean;
  isReferral: boolean;
}

interface SubscriptionList<T> {
  applyingSubscriptions: T[];
  subscriptions: T[];
}
export interface SubscriptionType {
  orderId: number;
  productName: string;
  promoCode: string;
  currency: string;
  amount: string;
  discountAmount: string;
  actualAmount: string;
  trialDays: number;
  dueDate: string;
}
export interface RewardItemType {
  code: string;
  currency: string;
  amount: number;
  referralAccount: string;
  createDate: string;
  availableDate: string;
  status: string;
  redeemBy: string;
}
export interface UserReferralInfo {
  myLink: string;
  visitCount: number;
  totalReferrals: number;
  totalReward: number;
  availableReward: number;
  rewardCurrency: string;
  rewards: RewardItemType[];
}
class PromoCodeApi {
  public getCouponList(currency: string) {
    return BaseServiceApi.get<CouponList<CouponType>>('/api/v2/ch/pc/uc1', { currency });
  }
  public getSubscriptionsList(lang: string, couponCode = '') {
    return BaseServiceApi.get<SubscriptionList<SubscriptionType>>('/api/v2/ch/pc/ap', { lang, coupon: couponCode });
  }
  public redeemCouponAtPlatform(orderId: number, couponCode: string) {
    return BaseServiceApi.post('/api/v2/ch/pc/ap', { orderId, couponCode });
  }
  public getUserReferralInfo() {
    return BaseServiceApi.get<UserReferralInfo>('/api/ch/m9/rp', {});
  }
  public deleteSubscription(orderId: number) {
    return BaseServiceApi.delete('/api/v2/ch/pc/ap', { orderId });
  }
}

export default new PromoCodeApi();
